<ion-app (click)="resetTimeout()">

  <!-- <app-header *ngIf="!standByRoute && !tools.surveyMode && !kioskRoute" style="z-index: 8"></app-header> -->
  
  <!-- <ion-router-outlet [ngClass]="(!standByRoute && !tools.surveyMode && !kioskRoute) ? 'marginContent' : ''">  -->
  <app-header *ngIf="tools.showHeader" style="z-index: 8"></app-header>
  <ion-router-outlet [animated]="true" [animation]="getAnimation()" style="position: relative; width: 100%; height: 100%;"> 
    <!-- <div style="z-index: 99999999999999; position: absolute;">IDLE_STATE: {{idleState}}, COUNTDOWN: {{countdown}}, LAST_PING: {{lastPing | date}}</div> -->
    <!-- <div *ngIf="!kioskRoute && !standByRoute" style=" position: fixed; bottom: 1.5%; right: 2%; width: 110px; height: 110px; z-index: 9999999;">
      <button (click)="presentAlert()" class="btnWeatherQR"><ion-icon name="chatbox-outline" class="qrIconTest"></ion-icon></button>
    </div> -->
  </ion-router-outlet>
  <app-overlay-spinner style="z-index: 9"></app-overlay-spinner>

  <div *ngIf="tools.isOffline" style="position: fixed; bottom: 0; right: 0; width: 10px; height: 10px; background-color: red;"></div>

  <div *ngIf="!kioskRoute && !standByRoute && !licenseRoute" (click)="goBack()" class="app-back-button">
    <ion-icon style="font-size: 6vw;" name="arrow-back-outline"></ion-icon>
  </div>

</ion-app>
